// © Microsoft Corporation. All rights reserved.

import { HighContrastColor, highContrastSelector } from "@microsoft/fast-components-styles-msft";

export const primaryDarkerColor = "#005CA4"; // darken(accentFillRest, 10%)
export const primaryFocusColor =    "#3EAAFF"; // lighten(accentFillRest, 20%)
export const dangerColor = "#dc3545";
export const dangerFocusColor = "#BA0C1B";
export const profileHrColor = "rgba(143, 158, 205, 0.2)";
export const secondaryBorderColor = "#BEBEBE";

/* Text-Color */
export const midDarkerTextColor = "#4F4F4F";
export const darkTextColor = "rgba(0, 0, 0, 0.83)";
export const primaryTextColor= "#0067B8";
export const secondaryTextColor= "#5E5E5E";
export const placeholderColor = "#949494";

/* Background Colors*/
export const darkerBgColor = "#cccccc"; // darken(lightBgColor,20%)

/* Component Based */

/* Shadow */
export const mainBoxShadow= "0px 4px 10px rgba(0, 0, 0, 0.12)"; // rgba(0, 0, 0, 0.12)

/* FONT */
export const mainFontSize = "16px";
export const mainLineHeight = "22px";

/* AVATAR */
export const avatarSize = "40px";

/* PROFILE */
export const profileSidePadding = "40px";
export const profileAvatarSize = "64px";

/* OTHER */
export const avatarPadding = "51px"; // calc(1.1rem + @avatar-size);
export const commentVPadding = "20px";
export const fontFamily = '"Segoe UI", "Segoe WP", -apple-system, BlinkMacSystemFont, Roboto, "Helvetica Neue", Arial, Sans-Serif';

/* RESET STYLES */
export const reset = {
    margin: "0",
    padding: "0",
    border: "0",
    "vertical-align": "baseline",
    "list-style": "none",

    "& *:not([class]),h1,h2,h3,h4,h5,h6": {
        margin: "0",
        padding: "0",
        border: "0",
        "vertical-align": "baseline",
        "list-style": "none"
    },

    "& ul, li": {
        "list-style": "none"
    }
};

/* HIGH CONTRAST */

export const highContrastButton = {
    [highContrastSelector]: {
        background: HighContrastColor.selectedBackground,
        transition: "none",
        "& *, &:focus *, &:hover *": {
            fill: HighContrastColor.selectedText
        }
    }
};

